import router from '@/router'
import uuid from 'uuid'
// eslint-disable-next-line object-curly-newline
import { reactive, getCurrentInstance, watch, toRefs } from '@vue/composition-api'

export const isObject = obj => typeof obj === 'object' && obj !== null

export const isToday = date => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

export const convertSecondsToTime = seconds => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = seconds % 60

  const formattedHours = String(hours).padStart(2, '0')
  const formattedMinutes = String(minutes).padStart(2, '0')
  const formattedSeconds = String(remainingSeconds).padStart(2, '0')
  if (hours > 0) {
    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
  }
  return `${formattedMinutes}:${formattedSeconds}`
}

export const convertTimeToSeconds = timeString => {
  const timeParts = timeString.split(':')
  const minutes = parseInt(timeParts[0])
  const seconds = parseInt(timeParts[1])

  if (isNaN(minutes) || isNaN(seconds)) {
    return null
  }
  if (seconds === 0 && minutes === 0) {
    return 0
  }
  return minutes * 60 + seconds
}

const getRandomFromArray = array => array[Math.floor(Math.random() * array.length)]

// ? Light and Dark variant is not included
// prettier-ignore
export const getRandomBsVariant = () => getRandomFromArray(['primary', 'secondary', 'success', 'warning', 'danger', 'info'])

export const isDynamicRouteActive = route => {
  const { route: resolvedRoute } = router.resolve(route)
  return resolvedRoute.path === router.currentRoute.path
}

// Thanks: https://medium.com/better-programming/reactive-vue-routes-with-the-composition-api-18c1abd878d1
export const useRouter = () => {
  const vm = getCurrentInstance().proxy
  const state = reactive({
    route: vm.$route,
  })

  watch(
    () => vm.$route,
    r => {
      state.route = r
    },
  )

  return { ...toRefs(state), router: vm.$router }
}

/**
 * This is just enhancement over Object.extend [Gives deep extend]
 * @param {target} a Object which contains values to be overridden
 * @param {source} b Object which contains values to override
 */
// export const objectExtend = (a, b) => {
//   // Don't touch 'null' or 'undefined' objects.
//   if (a == null || b == null) {
//     return a
//   }

//   Object.keys(b).forEach(key => {
//     if (Object.prototype.toString.call(b[key]) === '[object Object]') {
//       if (Object.prototype.toString.call(a[key]) !== '[object Object]') {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = b[key]
//       } else {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = objectExtend(a[key], b[key])
//       }
//     } else {
//       // eslint-disable-next-line no-param-reassign
//       a[key] = b[key]
//     }
//   })

//   return a
// }

// generate uuidv4
export const uuidv4 = () =>
  // eslint-disable-next-line no-bitwise
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0
    // eslint-disable-next-line no-bitwise, no-mixed-operators
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })

export const timestampToDate = timestamp => {
  // Convertendo o timestamp em milissegundos para segundos
  const timestampInSeconds = timestamp / 1000

  // Criando um objeto Date a partir do timestamp
  const dateObject = new Date(timestampInSeconds * 1000)

  // Obtendo os componentes da data
  const day = String(dateObject.getDate()).padStart(2, '0')
  const month = String(dateObject.getMonth() + 1).padStart(2, '0') // Mês é baseado em zero
  const year = dateObject.getFullYear()
  const hours = String(dateObject.getHours()).padStart(2, '0')
  const minutes = String(dateObject.getMinutes()).padStart(2, '0')

  // Formatando a data no formato "dd/mm/yyyy HH:mm"
  const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}`

  return formattedDate
}

export const formatDate = value => {
  if (!value) return ''

  // Extrair partes da data
  const [year, month, day] = value.slice(0, 10).split('-')

  // Formatar a data no formato "dd/mm/yyyy"
  return `${day}/${month}/${year}`
}

export const downloadPDF = async url => {
  const response = await fetch(url)
  const blob = await response.blob()

  // Cria um link temporário para download
  const downloadLink = document.createElement('a')
  downloadLink.href = URL.createObjectURL(blob)
  downloadLink.download = 'transaction.pdf'

  // Adiciona o link temporário à página e realiza o clique para iniciar o download
  document.body.appendChild(downloadLink)
  downloadLink.click()

  // Remove o link temporário da página
  document.body.removeChild(downloadLink)
}

export const getDataAposTresDias = () => {
  // Obtém a data atual
  const dataAtual = new Date();

  // Adiciona três dias à data atual
  dataAtual.setDate(dataAtual.getDate() + 3);

  // Formata a data para o formato ISO 8601
  const dataFormatada = dataAtual.toISOString();

  // Retorna a data formatada
  return dataFormatada;
}
